import { UserService } from '../../../services/user/user.service';
import { JackpotService } from '../../../../page/jackpot/jackpot.service';
import { EnvironmentService } from '../../../services/environment.service';

export interface BadgeConfig {
  type: string;
  priority: number;
  condition: (game: any, user: UserService, jackpot: JackpotService, env: EnvironmentService) => boolean;
}

const hasJackpotForUser = (game: any, user: UserService) => {
  return user?.auth && game?.externalData?.real?.[user?.currentCurrency?.currency]?.jackpot;
};

const hasJackpotForGuest = (user: UserService, game: any, env: EnvironmentService) => {
  return !user?.auth && (
    game?.externalData?.real?.[env?.env?.currency?.short] ||
    game?.externalData?.real?.['EUR']
  )?.jackpot;
};

export const BADGE_CONFIG: BadgeConfig[] = [
  {
    type: 'new',
    priority: 2,
    condition: (game) => !!game?.new
  },
  {
    type: 'popular',
    priority: 3,
    condition: (game) => !!game?.popular && !game?.new
  },
  {
    type: 'exclusive',
    priority: 4,
    condition: (game) => !!game?.prerelease
  },
  {
    type: 'jackpot',
    priority: 1,
    condition: (game, user, jackpot, env) => {
      if (!game?.jackpot) return false;
      return !(hasJackpotForUser(game, user) || hasJackpotForGuest(user, game, env));
    }
  },
  {
    type: 'mystery',
    priority: 5,
    condition: (game) => !!game?.mystery
  },
  {
    type: 'jackpotBadge',
    priority: 0,
    condition: (game, user, jackpot, env) => {
      return hasJackpotForUser(game, user) || hasJackpotForGuest(user,game, env);
    }
  },
  {
    type: 'freespins',
    priority: 4,
    condition: (game) => !!game?.freespins
  },
  {
    type: 'drops',
    priority: 5,
    condition: (game) => !!game?.drops
  }
];
